import { isNull } from '../utils/utils';

export const decimalFilter = (value: number, fractions: number, displayEmpty = false) => {
    if (isNull(value)) return ""

    const empty = displayEmpty ? value.toFixed(fractions) : ""

    return value
        ? value.toFixed(fractions)
        : empty
}
